import {Routes} from "@angular/router";
import {WorkflowCspOneTariffComponent} from "./workflow-csp-one-tariff.component";

export const workflowCspOneTariffRouting: Routes = [
    { path: 'csp/change-tariff/:aid', component: WorkflowCspOneTariffComponent, children: [
        { path: 'choose-tariff-variant', component: WorkflowCspOneTariffComponent, data: { step: 'choose-tariff-variant' } },
        { path: 'choose-tariff', component: WorkflowCspOneTariffComponent, data: { step: 'choose-tariff' } },
        { path: 'delivery-date', component: WorkflowCspOneTariffComponent, data: { step: 'delivery-date' } },
        { path: 'invoice-address', component: WorkflowCspOneTariffComponent, data: { step: 'invoice-address' } },
        { path: 'payment', component: WorkflowCspOneTariffComponent, data: { step: 'payment-method' } },
        { path: 'checkout-summary', component: WorkflowCspOneTariffComponent, data: { step: 'checkout-summary' } },
        { path: 'thank-you', component: WorkflowCspOneTariffComponent, data: { step: 'thank-you' } },
        { path: '', redirectTo: 'choose-tariff-variant', pathMatch: 'full' },
    ]},
]